import api from "@/axiosInstance.js";
import type { ApiRequestOptions, User } from "@/types/app";

export const getData = async (
    user: User | null | undefined,
    { signal }: ApiRequestOptions = {},
) => {
    if (user?.permissions?.includes("see_dp_progress_reports_1")) {
        const res = await api.get(`/svnbd/data/dp-report/progress`, { signal });
        // console.log(res.data.data)
        return res.data.data;
    }
    return null;
}
export const getVisitData = async (
    user: User | null | undefined,
    { signal }: ApiRequestOptions = {},
) => {
    if (user?.permissions?.includes("see_dp_progress_report_2")) {
        const res = await api.get(`/svnbd/data/dp-report/visit`, { signal });
        // console.log(res.data.data)
        return res.data.data;
    }
    return null;
}

